module.exports = __webpack_public_path__ + "static/media/min_light.ad0c8edc.svg";